import Wishlist from './pages/wishlist/wishlist';

document.addEventListener('DOMContentLoaded', () => {
  new Wishlist().init();
});
